import "./style.scss";

import Bank from "assets/img/svg/bank";
import Check from "assets/img/svg/check";
import Paypal from "assets/img/svg/paypal";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import IosSwitch from "../IosSwitch";

interface IPaymentMethod {
    paymentMethods: string[];
    handleChange: (methods: string[]) => void;
}

const PaymentMethod = ({ paymentMethods, handleChange }: IPaymentMethod) => {
    const [t] = useTranslation();

    const [methods, setMethods] = useState(paymentMethods);
    const [allowsBankTransfer, setAllowsBankTransfer] = useState(paymentMethods.includes("rib"));
    const [allowsPaypal, setAllowsPaypal] = useState(paymentMethods.includes("paypal"));
    const [allowsCheck, setAllowsCheck] = useState(paymentMethods.includes("check"));

    const handleToggleChange = (value: boolean, type: string) => {
        let newMethods = [...methods];
        if (type === "rib") {
            setAllowsBankTransfer((prev: boolean) => !prev);
            value ? newMethods.push("rib") : (newMethods = newMethods.filter((method: string) => method !== "rib"));
        }
        if (type === "paypal") {
            setAllowsPaypal((prev: boolean) => !prev);
            value
                ? newMethods.push("paypal")
                : (newMethods = newMethods.filter((method: string) => method !== "paypal"));
        }
        if (type === "check") {
            setAllowsCheck((prev: boolean) => !prev);
            value ? newMethods.push("check") : (newMethods = newMethods.filter((method: string) => method !== "check"));
        }
        setMethods(newMethods);
        handleChange(newMethods);
    };

    return (
        <div className="info-block">
            <div className="payment-method-title">
                <div className="title">{t("PaymentMethod.Title")}</div>
                {/* <p className='subtitle'>{t("PaymentMethod.Subtitle")}</p> */}
            </div>
            <div>
                <div className="info-block-list-element paymentOption">
                    <div className="flex items-center gap-2 text-sm">
                        <Bank />
                        {t("PaymentMethod.BankTransfer")}
                    </div>
                    <div className="switch">
                        <IosSwitch
                            checked={allowsBankTransfer}
                            onChange={(e: any) => handleToggleChange(e.target.checked, "rib")}
                        />
                    </div>
                </div>
                <div className="info-block-list-element paymentOption">
                    <div className="flex items-center gap-2 text-sm">
                        <Paypal />
                        {t("PaymentMethod.Paypal")}
                    </div>
                    <div className="switch">
                        <IosSwitch
                            checked={allowsPaypal}
                            onChange={(e: any) => handleToggleChange(e.target.checked, "paypal")}
                        />
                    </div>
                </div>
                <div className="info-block-list-element paymentOption">
                    <div className="flex items-center gap-2 text-sm">
                        <Check />
                        {t("PaymentMethod.Check")}
                    </div>
                    <div className="switch">
                        <IosSwitch
                            checked={allowsCheck}
                            onChange={(e: any) => handleToggleChange(e.target.checked, "check")}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentMethod;
